import type { InputRef } from 'antd';
import { useDebounceFn } from 'ahooks';
import { userApis } from '@/configs/apis/user';
import type { User } from '@/configs/apis/user';
import { useContactsContext } from '@/contexts/contacts/context';
import { useChatContext } from '@/contexts/chat/context';
import type { AddContactsModalProps } from './interface';
import styles from './index.module.scss';
import UserList from './user-list';

export default function AddContactsModal({ open, onCancel }: AddContactsModalProps) {
  const [users, setUsers] = useState<User[]>([]);
  const { contacts, addContacts } = useContactsContext();
  const { createChat, activeChat } = useChatContext();
  const inputRef = useRef<InputRef>(null);
  const [searchValue, setSearchValue] = useState('');
  const deferredSearchValue = useDeferredValue(searchValue);

  const { run: onSearch } = useDebounceFn(
    async () => {
      try {
        const res = await userApis.search(deferredSearchValue);
        setUsers(res);
      } catch (error) {
        console.error(error);
      }
    },
    { wait: 300 }
  );

  useEffect(() => {
    onSearch();
  }, [deferredSearchValue, onSearch]);

  useEffect(() => {
    let timer: number;
    if (open) {
      timer = window.setTimeout(() => {
        inputRef.current?.focus({
          cursor: 'end',
        });
      }, 350);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [open]);

  return (
    <Modal
      open={open}
      // cancelText="Cancel"
      // okText="Confirm"
      title={<div className={styles.title}>Add Contacts</div>}
      destroyOnHidden
      maskClosable={false}
      onCancel={onCancel}
      // onOk={onCancel}
      centered
      styles={{
        content: {
          padding: '24px 16px',
        },
      }}
      footer={null}
    >
      <div className={styles.addContactsModal}>
        <div className={styles.search}>
          <Input
            ref={inputRef}
            value={searchValue}
            prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            variant="filled"
            placeholder="Search"
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
        <UserList
          users={users}
          contacts={contacts}
          createChat={createChat}
          activeChat={activeChat}
          addContacts={addContacts}
          onCancel={onCancel}
        />
      </div>
    </Modal>
  );
}
